<app-dialog
  headerText="Product Blueprint: Initial Setup Completed "
  [body]="body"
  [showCancelButton]="true"
  cancelText="Close"
  [showSaveButton]="false"
  [showTopCancelButton]="false"
></app-dialog>

<ng-template #body>
  <div class="wrapper">
    <div>
      The initial setup of your product blueprint was successfully completed in
      the unified services framework. <br /><br />
      These resources were generated in {{ rootPath }}:
    </div>

    <ul class="margin-bottom">
      <li>
        <div class="resource-container">
          <div class="text">
            <span class="max-lines">{{ payload.baseFolderName }}</span>
            <span>(Folder)</span>
          </div>
        </div>
        <ul>
          <li>
            <div class="resource-container">
              <div class="text">
                <span class="max-lines">{{ payload.managedServiceName }}</span>
                <span>(ManagedService)</span>
              </div>
            </div>
          </li>
          <li>
            <div class="resource-container">
              <div class="text">
                <span class="max-lines">{{
                  payload.servicePublishConfiguration.name
                }}</span>
                <span>(ServicePublishConfiguration)</span>
              </div>
            </div>
          </li>
          <li>
            <div class="resource-container">
              <div class="text">
                <span class="max-lines">{{
                  stepSetupParameters.serviceMetadata.name
                }}</span>
                <span>(ServiceMetadata)</span>
              </div>
            </div>
          </li>
          <li>
            <div class="resource-container">
              <div class="text">
                <span class="max-lines">{{ payload.resourceGroupName }}</span>
                <span>(ResourceGroup)</span>
              </div>
            </div>
            <ul>
              @for (
                businessType of stepSetupParameters.businessTypes;
                track businessType
              ) {
                <li>
                  <div class="resource-container">
                    <div class="text">
                      <span class="max-lines">{{
                        businessType.btpBlueprint.name
                      }}</span>
                      <span>(BTPBlueprint)</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="resource-container">
                    <div class="text">
                      <span class="max-lines">{{
                        businessType.resourceTypeDefinition.name
                      }}</span>
                      <span>(ResourceTypeDefinition)</span>
                    </div>
                  </div>
                </li>
              }
            </ul>
          </li>
          <li>
            <div class="resource-container">
              <div class="text">
                <span class="max-lines">{{ payload.testFolderName }}</span>
                <span>(Folder)</span>
              </div>
            </div>
            <ul>
              <li>
                <div class="resource-container">
                  <div class="text">
                    <span class="max-lines">{{
                      payload.testResourceGroupName
                    }}</span>
                    <span>(ResourceGroup)</span>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <div>
      <strong>What are your next steps?</strong><br />
      Follow the instructions in our
      <a
        fd-link
        href="https://pages.github.tools.sap/atom-cfs/atom-docs/docs/how-to-guides/provision-your-app/provision-your-saas-app-urm/#2-suite-level-onboarding-steps"
        [emphasized]="true"
        target="_blank"
        >how-to guide</a
      >
      to continue the onboarding journey of your product blueprint.
    </div>
  </div>
</ng-template>
